import { ResearchAudienceTypeEnum } from './audience-type.enum';
import { Query } from './deploy-to-panel/query/query.model';
import { IParticipantsCommunications } from './participant-communications/participant-communications.interface';
import { TargetAudienceRow } from './target/target-audience-row.model';
import { IThirdPartyProviderFeasibility } from './third-party-provider/audience-feasibility.interface';
import { IThirdPartyProviderFinalize } from './third-party-provider/audience-finalize.interface';
import { AudienceStatusEnum } from './third-party-provider/audience-status.enum';
import { IFeasibilityAndPrice } from './third-party-provider/feasibility-and-price.model';
import { ProjectEndPages } from '../project-end-pages.interface';

export class ResearchAudience {
  id: string;
  name: string;
  targetCompletes?: number;
  language: string;
  audienceType: ResearchAudienceTypeEnum;
  endPages?: ProjectEndPages;
  directRecruitmentInvites?: TargetAudienceRow[];
  qualifications?: Query;
  participantCommunications?: IParticipantsCommunications;
  feasibility?: IThirdPartyProviderFeasibility;
  finalize?: IThirdPartyProviderFinalize;
  feasibilityResult?: IFeasibilityAndPrice;
  closedInd: boolean;
  status: AudienceStatusEnum;
}
